export default __webpack_public_path__ + "static/community_event_1-2e40c7649eee1292f39b7d4d0107aa8a.jpg";